<template>
  <div class="fill-height">
    <v-toolbar class="border-top" dense color="white" ligth>
      <v-spacer></v-spacer>

      <v-menu bottom>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <span>{{ unread_text }}</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item-group v-model="filter.unread" color="primary">
            <v-list-item v-for="(item, i) in filters.unread" :key="i" :value="item.value">
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-divider vertical class="mx-3" inset v-if="$vuetify.breakpoint.smAndUp"></v-divider>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-menu bottom>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <span>{{ order_by_text }}</span>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group v-model="filter.order_by" color="primary">
              <v-list-item v-for="(item, i) in filters.order_by" :key="i" :value="item.value">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn icon text @click="filter.dir == 'asc' ? filter.dir = 'desc' : filter.dir = 'asc'">
          <v-icon small>{{ filter.dir == 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
        </v-btn>
      </template>

      <template v-if="$vuetify.breakpoint.xsOnly" #extension>
        <v-spacer></v-spacer>

        <v-menu bottom>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <span>{{ order_by_text }}</span>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group v-model="filter.order_by" color="primary">
              <v-list-item v-for="(item, i) in filters.order_by" :key="i" :value="item.value">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn icon text @click="filter.dir == 'asc' ? filter.dir = 'desc' : filter.dir = 'asc'">
          <v-icon small>{{ filter.dir == 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
        </v-btn>
      </template>
    </v-toolbar>

    <v-container>
      <v-progress-linear v-if="loading" color="primary" :height="5" indeterminate top absolute></v-progress-linear>

      <v-layout align-start justify-center fill-height id="my-notifications" class="mb-8 pb-8 pt-2">
        <v-flex xs12>
          <server-side-iterator
            :pagination="pagination"
            :loading="loading"
            v-on:paginate="paginate"
            :grid="{xs12:true, sm12:true, lg6:true}"
          >
            <template v-slot:default="item">
              <list-item
                class="ma-1"
                v-bind="item"
                :saving="instance_saving"
                :deleting="instance_deleting"
                @read="read"
                @unread="unread"
                @delete="deleteItem"
              ></list-item>
            </template>
            <template v-slot:no-data>
              <v-alert class="py-5 my-5" elevation="2">
                <div class="text-center">{{ trans('notification.no_notifications_message') }}</div>
              </v-alert>
            </template>
          </server-side-iterator>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import NotificationItem from "../components/NotificationItem";

export default {
  components: {
    "list-item": NotificationItem
  },

  data: () => ({
    filters: {
      deleted: [
        { text: "Show all", value: null },
        { text: "Only trashed", value: "yes" },
        { text: "Without trashed", value: "no" }
      ],
      unread: [
        { text: "Show all", value: null },
        { text: "Only unread messages", value: "yes" },
        { text: "Only read messages", value: "no" }
      ],
      order_by: [
        { text: "Date of receipt", value: "created_at" },
        { text: "Reading date", value: "read_at" }
      ]
    },
    filter: {
      deleted: "no",
      unread: "yes",
      order_by: "created_at",
      dir: "desc"
    }
  }),

  watch: {
    filter: {
      handler: function(value) {
        let query = Object.assign({}, value);
        console.log(query);
        query = _.omitBy(query, e => e == null || e == 0);
        console.log(query);
        this.setQuery(query);
        this.fetch();
      },
      deep: true
    }
  },

  computed: {
    ...mapState("notifications", {
      pagination: "pagination",
      loading: "fetching",
      query: "query",
      instance_saving: "instance_saving",
      instance_deleting: "instance_deleting"
    }),
    unread_text: function() {
      try {
        return this.filters.unread.find(x => x.value == this.filter.unread)
          .text;
      } catch (e) {
        return this.filters.unread[0].text;
      }
    },
    order_by_text: function() {
      try {
        return this.filters.order_by.find(x => x.value == this.filter.order_by)
          .text;
      } catch (e) {
        return this.filters.order_by[0].text;
      }
    }
  },

  methods: {
    ...mapActions("notifications", {
      fetch: "fetch",
      setQuery: "setQuery",
      setQueryParam: "setQueryParam",
      read: "read",
      unread: "unread",
      deleteItem: "delete"
    }),

    paginate: function(page) {
      this.setQueryParam({ page: page });
      this.fetch();
    }
  },

  mounted: function() {
    this.fetch();
    this.$store.subscribe(({ type, payload }, state) => {
      if (type == "notifications/handleStatus" && payload.instance_deleted) {
        this.fetch();
      }
      if (type == "notifications/handleStatus" && payload.instance_saved) {
        this.fetch();
      }
    });
  }
};
</script>